<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="pa-0 ma-0 mt-0 pt-0 "></v-breadcrumbs>
    <v-layout row wrap class="mt-4">
      <v-flex sm12 xs12 md12 lg12>
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
             Model Selector
          </v-card-title>
            <v-row class="ml-2">
              <v-flex lg12 md12>
                <div class="mt-6">
                  <v-menu offset-y class="ml-2">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ma-2 ml-4 mb-4" small outlined rounded
                        color="#0471A5"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >
                        Topik<v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <!--list topic-->
                    <v-list>
                      <v-list-item v-for="(item, index) in topic" :key="index">
                        <v-list-item-title class="body-2">{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <!--end list topic-->
                  </v-menu>

                  <!--list pilihan model-->
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ma-2 ml-2 mb-4 elevation-0" small rounded outlined
                        color="#0471A5" dark v-bind="attrs" v-on="on">
                          Pilihan Model
                        <v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item>
                          <v-list-item-title class="body-2">BiLSTM</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title class="body-2">GRU</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title class="body-2">FastText</v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                  <!--end list periode berita-->

                  <v-btn class="ma-2 ml-2 mb-4" small rounded color="#0471A5" dark>
                    Terapkan
                  </v-btn>
                </div>
              </v-flex>
            </v-row>
            
          <v-col cols="12" lg="12" class="mb-4">
            <v-card-title class="primary--text">Model A</v-card-title>
            <v-card-subtitle class="body-1 font-weight-regular mt-2">Model Kepuasaan Pelanggan</v-card-subtitle>
            <v-card-text align="justify">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
              when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
              It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. 
              It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
              and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </v-card-text>
          </v-col>
        </v-card>

        <v-card class="rounded-lg mt-8" style="border-radius: 15px;" flat>
          <v-col cols="12" lg="12" class="mb-4">
            <v-row class="mx-1 mt-2">
              <v-flex lg12 md12>
                <v-card-title class="primary--text">Test Model Training</v-card-title>
                <v-divider class="mx-3"></v-divider>
              </v-flex>
            </v-row>
  
            <v-row class="mx-1 mt-4">
              <v-flex lg8 md8>
                <v-card-subtitle>
                  <h3 class="card-title">Pemilihan Dataset</h3>
                  <div>Pemilihan Dataset untuk uji training</div>
                </v-card-subtitle>
              </v-flex>

              <v-flex lg4 md4>
                <v-card-text class="d-flex align-end flex-column">
                  <div>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small rounded
                          color="#0471A5"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          Topik<v-icon small>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <!--list topic-->
                      <v-list>
                        <v-list-item v-for="(item, index) in topic" :key="index">
                          <v-list-item-title class="body-2">{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <!--end list topic-->
                    </v-menu>     
                  </div>
                </v-card-text>
              </v-flex>
            </v-row>

            <v-simple-table class="mx-6 table-striped my-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Asal data</th>
                    <th class="text-left">Timestamp</th>
                    <th class="text-left">Kalimat</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{ item.data }}</td>
                    <td>{{ item.timestamp }}</td>
                    <td>{{ item.kalimat }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            
            <v-row class="mx-1 my-6">
              <v-flex lg8 md8>
                <v-card-subtitle>
                  <h3 class="card-title">Pemilihan Model</h3>
                  <div>Model yang akan digunakan untuk uji training</div>
                </v-card-subtitle>
              </v-flex>

              <v-flex lg4 md4>
                <v-card-text class="d-flex align-end flex-column">
                  <div>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small rounded
                          color="#0471A5"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          Model<v-icon small>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <!--list topic-->
                      <v-list>
                        <v-list-item v-for="(item, index) in model" :key="index">
                          <v-list-item-title class="body-2">{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <!--end list topic-->
                    </v-menu>   
                  </div>
                </v-card-text>
              </v-flex>
            </v-row>

            <div align="center" justify="center" class="my-8">
              <v-btn color="#0471A5" dark outlined class="elevation-0" rounded width="300px">
                Run Test
              </v-btn>
            </div>

            <!--card content code 1-->
            <v-row class="ma-4 mt-10">
              <v-tabs color="#0471A5">
                <v-tab>Netral 
                  <v-chip small class="ma-2" color="#0471A5" text-color="white">
                    45,95%
                  </v-chip>
                </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="auto" flat>
                    <v-row class="mb-4 mt-4">
                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab>
                    Negatif <v-chip small class="ma-2" color="#0471A5" text-color="white">45,95%</v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="auto">
                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>
                    </v-card>
                  </v-tab-item>

                  <v-tab>Positif 
                    <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                      45,95%
                    </v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="auto">
                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg12>
                        <v-list-item class="grow ml-4">
                          <v-list-item-content>
                            <v-list-item-title>List-Based media object</v-list-item-title>
                            <v-list-subtitle class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            </v-list-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-btn class="ml-8" small
                          outlined
                          rounded
                          dark
                          color="#0471A5"
                          >
                          open
                        </v-btn>
                      </v-flex>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-row>
            </v-col>
          </v-card>
        </v-flex>
    </v-layout>
  </div>
</template>

<script scoped>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Model Selector',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
        desserts: [
          {
            data: 'value 1',
            timestamp: 'value 2',
            kalimat: 'value 3'
          },
          {
            data: 'value 1',
            timestamp: 'value 2',
            kalimat: 'value 3'
          },
          {
            data: 'value 1',
            timestamp: 'value 2',
            kalimat: 'value 3'
          },
          {
            data: 'value 1',
            timestamp: 'value 2',
            kalimat: 'value 3'
          },
        ],
        items: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Model Selector',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
      ],
      /*Bubblechart*/
       chart: [
        {
          name: 'Jokowi',
          amount: 25,
          color: '#F88FB3'
        },
        {
          name: 'Anies Baswedan',
          amount: 10,
          color: '#F1E987'
        },
        {
          name: 'SBY',
          amount: 15,
          color: '#B3B8F4'
        },
        {
          name: 'Ganjar',
          amount: 10,
          color: '#5EC3C2',
        },
        {
          name: 'Risma',
          amount: 5,
          color: '#AFDAF5'
        },
        {
          name: 'Sandiuno',
          amount: 6,
          color: '#C4C4C4'
        },
      ],
      /*end Bubblechart*/

      menuperiode: false,
      menu:false, 
      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: '2013-07-29',
      topic: [
        { title: 'Corona'},
        { title: 'Teknologi'},
        { title: 'Bisnis'},
        { title: 'Sains'},
      ],
      model: [
        { title: 'Model A'},
        { title: 'Model B'},
        { title: 'Model C'},
        { title: 'Model D'},
      ],
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
}
</script>

<style scoped> 
/*note css jangan diubah*/

#app{
  background-color: #f7f6f4;
}
tbody tr:nth-of-type(even) {
    background-color: #fff;
  }

  tbody tr:nth-of-type(odd) {
    background-color: #E7F2F7;
  }

  .v-data-table-header {
    background-color: #fff;
    color: white;
  }

  .v-data-footer {
    background-color: #E7F2F7;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>
